import { Tabs } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  .ant-card {
    .card-content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .ant-space {
      flex-wrap: wrap;
    }

    .status-menu-divider {
      font-size: 0.9rem;
      opacity: 0.6;
      margin: 12px 0;
    }
  }

  /* Ocultar o scroll fixo quando não for necessário */
  .ant-table-container::before {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 1px;
    pointer-events: none;
    z-index: 999;
  }

  /* Ocultar condicionalmente o scroll fixo quando o final da tabela estiver visível */
  &.table-bottom-visible .ant-table-sticky-scroll {
    visibility: hidden !important;
    opacity: 0 !important;
    transition: visibility 0.2s, opacity 0.2s;
  }

  /* Mostrar o scroll fixo quando o final da tabela não estiver visível */
  &:not(.table-bottom-visible) .ant-table-sticky-scroll {
    visibility: visible !important;
    opacity: 1 !important;
    transition: visibility 0.2s, opacity 0.2s;
  }

  /* Melhorar o estilo do scroll fixo */
  .ant-table-sticky-scroll {
    box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.1);
    background: ${({ theme }) => theme.colors.background};
    border-radius: 4px 4px 0 0;

    .ant-table-sticky-scroll-bar {
      background: ${({ theme }) => theme.colors.border};
      border-radius: 3px;
      height: 6px !important;
    }
  }
`;

export const CardTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  .card-title-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .card-title-left-total {
      font-size: 0.7rem;
      opacity: 0.5;
      margin-left: 8px;
    }

    .card-title-left-right {
      display: inline-flex;
      align-items: center;
    }
  }

  .card-title-right {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > button,
    > div {
      margin-left: 8px;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;
    justify-content: center;
    padding: 4px 0;

    .card-title-left {
      justify-content: center;
    }
    .card-title-right {
      margin-top: 4px;
    }
  }
`;

export const StatusMenuContainer = styled.div`
  padding: 8px;
  background: ${({ theme }) => theme.colors.background1};
  border-radius: ${({ theme }) => theme.shapes.borderRadius};
  border: 1px solid ${({ theme }) => theme.colors.border};
  margin-bottom: 16px;

  .ant-btn-default {
    border-color: ${({ theme }) => theme.colors.border};
  }

  .ant-tabs-tab {
    background: ${({ theme }) => theme.colors.background} !important;
  }
`;

export const TabsContainer = styled(Tabs)<{ showFilters?: boolean }>`
  padding: 0 16px;
  background: ${({ showFilters, theme }) =>
    showFilters
      ? theme.colors.background
      : theme.colors.background1} !important;
  border: 1px solid transparent;
  border-top-color: ${({ theme }) => theme.colors.border};
  border-bottom-color: ${({ theme }) => theme.colors.border};
  margin-bottom: 16px;
  border-radius: ${({ theme }) => theme.shapes.borderRadius};

  .ant-tabs-tab-active {
    background: transparent !important;
  }
`;
